module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-management"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("accountInfo.title")))])])]), _vm._v(" "), _c('div', {
    staticClass: "com-container"
  }, [_c('table', {
    staticClass: "act-ifmTable"
  }, [_c('tr', [_c('td', {
    staticClass: "tab-tit",
    attrs: {
      "width": "210"
    }
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.username")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab-tit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.email")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab-tit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.registerDate")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.created))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab-tit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.status")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.status))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab-tit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.lastDate")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab-tit"
  }, [_vm._v(_vm._s(_vm.$t("accountInfo.lastIp")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ip))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e1e64e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AccountManagement/AccountInformation.vue
// module id = 977
// module chunks = 1